/* eslint-disable prettier/prettier */
import { Message } from "../Utils/Message";
/**
 * Refiner tooltip messages
 */
export const Messages = {
    EXPAND_COLLAPSE_REFINER: new Message("EXPAND_COLLAPSE_REFINER", "Show {0}"),
    CLOSE_REFINER: new Message("REFINER_CLOSE", "Close Refiner"),
    EXPAND_COLLAPSE_GROUP: new Message("EXPAND_COLLAPSE_GROUP", "{0}"),
    YES: new Message("YES", "Yes"),
    NO: new Message("NO", "No")
};
